function forever(key, callback) {
  if (typeof(Storage) === 'undefined') {
    return callback();
  }

  let result = localStorage.getItem(key);

  if (result) {
    return JSON.parse(result);
  }

  result = callback();

  localStorage.setItem(key, JSON.stringify(result));

  return result;
}

export default {
  forever: forever
}
